import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { useTranslation } from 'react-i18next';

import useCartFooter from './hooks/useCartFooter';

interface Props {
    shopId: string;
    cartId?: string;
}

function CartFooter({ shopId, cartId }:Props) {
    const { t } = useTranslation('cart');
    const {
        handleOrder, totalAmount, isEmpty, isAllSoldOuted,
    } = useCartFooter({ shopId, cartId });
    const priceUnit = usePriceUnit();
    return (
        <Column spacing={16} fullWidth>
            <Column spacing={8} fullWidth>
                <Row justify='space-between' fullWidth>
                    <Text size='lg' color={colors.gray6} fontWeight='bold'>
                        {t('footer.productAmount')}
                    </Text>
                    <Text size='lg'>{totalAmount.toLocaleString()}{priceUnit}</Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text size='xl' fontWeight='bold'>
                        {t('footer.paymentAmount')}
                    </Text>
                    <Text size='3xl' fontWeight='bold' color={colors.red}>
                        {totalAmount.toLocaleString()}{priceUnit}
                    </Text>
                </Row>
            </Column>
            <Button fullWidth onClick={handleOrder}
                disabled={isAllSoldOuted || isEmpty} >
                {isAllSoldOuted ? t('footer.soldOut') : t('footer.order')}
            </Button>
        </Column>
    );
}

export default CartFooter;
